import * as agendaStyles from "../../../styles/widgets/agenda.module.scss";

import {Link} from "gatsby";
import React from "react";
import clsx from "clsx";
import {getDisplayLang} from "../../../utils/parsing";

const Agenda = ({title, link, date, url, eventLanguage, locale}) => {
    let parsedDate = new Date(date).toLocaleString("fr-FR", {
        day: "2-digit", month: "2-digit",
    });
    let displayLang = getDisplayLang(eventLanguage, locale);
    if (!link) {
        link = '#'
    }

    return (<Link style={{display: "block"}} to={link}>
        <div
            className={clsx(agendaStyles.bloc, {
                [agendaStyles.hover]: Boolean(link) || Boolean(url),
            })}
        >
            <div className={agendaStyles.innerBloc}>
                <div
                    className={agendaStyles.mainBloc}
                >
                    <div className={agendaStyles.itemMainBloc}>
                        <div
                            className={agendaStyles.titleAgenda}
                        >
                            <p className={agendaStyles.h3}>
                                AGENDA
                            </p>
                        </div>
                        <div className={agendaStyles.containerDate}>
                            {date?.length > 4 && (<div>
                                <p
                                    className={clsx(agendaStyles.h1, agendaStyles.h1_hover)}
                                >
                                    {`${parsedDate[0]}${parsedDate[1]}`}
                                </p>
                                <p
                                    className={agendaStyles.h1}
                                >
                                    /
                                </p>
                                <p
                                    className={clsx(agendaStyles.h2, agendaStyles.h2_hover)}
                                >
                                    {`${parsedDate[3]}${parsedDate[4]}`}
                                </p>
                            </div>)}
                        </div>
                        <div className={agendaStyles.containerTitle}>
                            <p className={clsx(agendaStyles.agendaH4, agendaStyles.h4)} lang={displayLang}>
                                {title}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Link>);
};

export default Agenda;
